import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { ClasseFabbricato } from 'src/app/models/classe-fabbricato';
import { ClasseFabbricatoService } from 'src/app/services/classe-fabbricato.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { ClassiFabbricatoFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'classi-fabbricato',
  templateUrl: './classi-fabbricato.component.html',
  styleUrls: ['./classi-fabbricato.component.scss']
})
export class ClassiFabbricatoComponent implements OnInit {

  headingText: string = 'Tipi di danno';


  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),

  ];
  constructor(public classeFabbricatoService: ClasseFabbricatoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<ClassiFabbricatoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un tipo di danno';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }
  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (classeFabbricato: ClasseFabbricato) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il tipo di danno ${classeFabbricato.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.classeFabbricatoService.delete(classeFabbricato);
          this.toast.success('Tipo di danno eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione tipo di danno fallita.", "Errore!");
    }
  }



  editFunction = async (classeFabbricato: ClasseFabbricato) => {
    try {
      let dialogRef = this.dialog.open(ClassiFabbricatoFormComponent, { data: classeFabbricato });
      dialogRef.afterClosed().subscribe(async (data: ClasseFabbricato) => {
        if (data) {

          Object.assign(classeFabbricato, data);

          await this.classeFabbricatoService.edit(classeFabbricato);

          this.toast.success('Tipo di danno modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica tipo di danno fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(ClassiFabbricatoFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(classeFabbricato?: ClasseFabbricato) {
    if (classeFabbricato) {
      try {
        await this.classeFabbricatoService.create(classeFabbricato)
        this.toast.success('Tipo di danno creato!')
      }
      catch (e) {
        this.toast.error('Creazione tipo di danno fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
